"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskNestedFragments = exports.unsafe_readResult = exports.maskFragments = exports.readFragment = exports.initGraphQLTada = exports.graphql = void 0;
exports.mergeFragments = mergeFragments;
const tslib_1 = require("tslib");
const gql_tada_1 = require("gql.tada");
const merge_1 = tslib_1.__importDefault(require("lodash/merge"));
exports.graphql = (0, gql_tada_1.initGraphQLTada)();
var gql_tada_2 = require("gql.tada");
Object.defineProperty(exports, "initGraphQLTada", { enumerable: true, get: function () { return gql_tada_2.initGraphQLTada; } });
Object.defineProperty(exports, "readFragment", { enumerable: true, get: function () { return gql_tada_2.readFragment; } });
Object.defineProperty(exports, "maskFragments", { enumerable: true, get: function () { return gql_tada_2.maskFragments; } });
Object.defineProperty(exports, "unsafe_readResult", { enumerable: true, get: function () { return gql_tada_2.unsafe_readResult; } });
// declare function maskNestedFragments<const Fragments extends readonly FragmentShape[], Shape = resultOfFragmentsRec<Fragments>>(
//   _fragments: Fragments,
//   children: Pick<Shape, $tada.fragmentRefs>,
//   fragment: Omit<Shape, $tada.fragmentRefs>,
// ): fragmentRefsOfFragmentsRec<Fragments> {}
const maskNestedFragments = (_fragments, children, fragment) => {
    return (0, merge_1.default)({}, children, fragment); // eslint-disable-line
};
exports.maskNestedFragments = maskNestedFragments;
function mergeFragments(a, b, c, d, e, f, g, h) {
    return (0, merge_1.default)(a, b, c, d, e, f, g, h); // eslint-disable-line
}
//# sourceMappingURL=tada.js.map